import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import FundSimulatorApp from './components/VCCarrySimulator.tsx';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <nav>
            <ul className="menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/vccarry-simulator">VCCarry Simulator</Link>
              </li>
            </ul>
          </nav>
          <Routes>
            <Route path="/vccarry-simulator" element={<FundSimulatorApp />} />
            <Route path="/" element={<h1>Bem-vindo ao Simulador de Carry de Venture Capital!</h1>} />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
